import { render } from "./EmailManager.vue?vue&type=template&id=13280c8a&scoped=true"
import script from "./EmailManager.vue?vue&type=script&lang=js"
export * from "./EmailManager.vue?vue&type=script&lang=js"

import "./EmailManager.vue?vue&type=style&index=0&id=13280c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13280c8a"]])

export default __exports__